import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const InfoIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue88e'}</MuiIcon>
    );
}
